<template>
  <v-app>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-toolbar>
          <v-icon>cloud</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;Manejo de Días de Cobro</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                textB1681
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)">
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-layout row>
            <v-flex xs12 sm6 md3 lg3>
              <v-text-field v-model="filtro.anio" label="Año"> </v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3 lg3>
              <v-text-field v-model="filtro.mes" label="Mes"> </v-text-field>
            </v-flex>

            <v-flex lg3 sm6 xs12>
              <v-select
                v-model="filtro.tipoSubSituacionLaboralId"
                :items="listSubSituacionesLaborales"
                item-text="descripcion"
                item-value="id"
                label="Sub-Situación Laboral" />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-spacer></v-spacer>
            <v-flex xs12 sm6 md3 lg3 fluid>
              <v-btn color="success" @click="getItems(true)">Consultar</v-btn>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex>
              <v-card>
                <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Lista</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>

                <v-data-table
                  dense
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :rows-per-page="pagination.rowsPerPage"
                  :options.sync="pagination"
                  v-model="selectedRow"
                  :loading="loading"
                  class="elevation-1"
                  :footer-props="footer">
                  <template v-slot:no-data>
                    <v-alert
                      v-if="!primeraBusquedaRealizada"
                      :value="true"
                      color="grey lighten-3"
                      icon="info">
                      Ingrese los filtros para realizar la búsqueda
                    </v-alert>
                    <v-alert v-else :value="true" color="grey" icon="warning">
                      No se encontraron registros con los filtros ingresados
                    </v-alert>
                  </template>

                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-xs-left caption">
                        <tr>
                          {{
                            item.anio
                          }}
                        </tr>
                      </td>

                      <td class="text-xs-left caption">
                        <tr class="text-xs-left font-weight-light caption">
                          {{
                            item.mes
                          }}
                        </tr>
                      </td>

                      <td class="text-xs-left caption">
                        <tr class="text-xs-left font-weight-light caption">
                          {{
                            item.ultimoDigitoDNI
                          }}
                        </tr>
                      </td>

                      <td class="text-xs-left caption">
                        <tr>
                          <!-- <v-select
                            v-model="item.tipoSubSituacionLaboralId"
                            :items="listSubSituacionesLaborales"
                            item-text="descripcion"
                            item-value="id"
                            disabled="true" /> -->

                          {{
                            getSubSituacionDescripcion(
                              item.tipoSubSituacionLaboralId,
                            )
                          }}
                        </tr>
                      </td>
                      <td class="text-xs-left caption">
                        {{
                          item.fechaCobro
                            | dateParse("YYYY-MM-DD")
                            | dateFormat("DD-MM-YYYY")
                        }}
                      </td>
                      <td class="text-xs-left caption">{{ item.diaCobro }}</td>

                      <td class="text-xs-left">
                        <v-icon
                          small
                          class="mr-2"
                          @click="editItem(item)"
                          v-show="canUpdate"
                          >edit</v-icon
                        >
                        <v-icon
                          small
                          @click="eliminarRegistro(item)"
                          v-show="canDelete"
                          >delete</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>

                <v-row>
                  <v-col>
                    <v-btn @click.stop="altaRegistro()" color="indigo" dark>
                      Dar de Alta un Registro</v-btn
                    >
                  </v-col>
                </v-row>

                <v-card-actions>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="3">
                        <v-btn
                          color="info"
                          v-if="records.length > 0"
                          :disabled="loading"
                          @click="imprimirListado"
                          >Imprimir Listado</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>

          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
          <template v-if="$store.state.debugModeOn">
            Debug Info:
            <p></p>

            Model: {{ filtro }}
            <p></p>
          </template>
          <v-divider></v-divider>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      editMode: false,
      suspend: false,
      filterChanged: false,
      search: "", // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 20, 50],
      },
      totalItems: 0, // va afuera de pagination
      headers: [],
      records: [], // registros
      selectedRow: [],
      filtro: {
        anio: new Date().getFullYear(),
        mes: new Date().getMonth() + 1,
        subTipoSituacionLaboralId: 0,
        // limit: 900,
        // page: 1,
        // sortBy: "Anio,Mes",
        // descending: false,
      },
      listSubSituacionesLaborales: [],
    };
  },
  async created() {
    // definición de columnas
    this.headers.push({ text: "Año", value: "anio" });
    this.headers.push({ text: "Mes", value: "mes" });
    this.headers.push({ text: "Últ. Dig. Doc.", value: "ultimoDigitoDNI" });
    this.headers.push({
      text: "Sub-Tipo Situación",
      value: "tipoSubSituacionLaboralId",
    });
    this.headers.push({ text: "Fecha Cobro", value: "fechaCobro" });
    this.headers.push({ text: "Día Cobro", value: "diaCobro" });
    this.headers.push({
      text: "Acciones",
      value: "accion",
      width: 80,
      sortable: false,
    });

    this.loadSubSituacionesLaborales();
  },
  watch: {
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems(false);
      },
      deep: true,
    },
    search() {
      this.getItems(true);
    },
  },
  computed: {
    ...mapGetters([
      "checkCanCreate",
      "checkCanUpdate",
      "checkCanDelete",
      "checkCanAccess",
      "getActionFromLink",
      "error",
      "user",
    ]),

    subSituacionLaboralDescripcion() {
      if (!this.item) {
        return "";
      }

      const itema = this.listSubSituacionesLaborales.find(
        (x) => x.id == this.item.tipoSubSituacionLaboralId,
      );

      return itema ? itema.descripcion : "";
    },

    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    // deshabilitarConsultar: function () {
    //   return (
    //     this.loading || !this.canalesVenta || this.canalesVenta.length == 0
    //   );
    // },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente", "cancelarAnalisis"]),
    puedeRetomar(item) {
      return (
        item.subEstado == "Cupo Aprobado" ||
        item.subEstado == "Cupo Modificado" ||
        item.subEstado == "Consulta Pendiente"
      );
    },

    getSubSituacionDescripcion(id) {
      const item = this.listSubSituacionesLaborales.find((x) => x.id == id);
      return item ? item.descripcion : "";
    },

    async altaRegistro() {
      var params = {
        width: 900,
        visible: true,
        registroId: "00000000-0000-0000-0000-000000000000",
      };

      this.setActiveTask({ task: "manejo-fechas-cobro", props: params });

      await this.getItems(true);
      this.saving = true;
    },

    async eliminarRegistro(item) {
      var params = {};
      params.id = item.id;
      params.tipoSubSituacionLaboralId = item.tipoSubSituacionLaboralId;
      params.anio = item.anio;
      params.mes = item.mes;
      params.ultimoDigitoDNI = item.ultimoDigitoDNI;
      params.fechaCobro = item.fechaCobro;
      params.diaCobro = item.diaCobro;
      params.EstadoId = 8;
      try {
        this.saving = true;
        await http.post(
          "Cobranzas/updateCalendario",
          JSON.stringify({ CalendarioANSES: params }),
        );
        this.alertSuccess("El registro ha sido eliminado.");
      } catch (error) {
        // Error
        this.alertError(error);
      }
      await this.getItems(true);
      this.saving = true;
    },

    async getItems(resetPagination) {
      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;
      // alert(filter.tipoSubSituacionLaboralId);

      if (filter.tipoSubSituacionLaboralId == "(Todos)") {
        filter.tipoSubSituacionLaboralId = 0;
      }
      const subTipoSituacionLaboralId = filter.tipoSubSituacionLaboralId || 0;

      if (subTipoSituacionLaboralId === null) {
        this.subTipoSituacionLaboralId = 0;
      }

      try {
        var result = await http.get(
          "Cobranzas/listfechascobro?anio=" +
            filter.anio +
            "&mes=" +
            filter.mes +
            "&subTipoSituacionLaboralId=" +
            subTipoSituacionLaboralId +
            "&limit=" +
            this.pagination.itemsPerPage +
            "&page=" +
            this.pagination.page +
            "&sortby=Anio,Mes" +
            //this.pagination.sortBy +
            "&descending=" +
            (this.pagination.sortDesc.length > 0
              ? this.pagination.sortDesc
              : "false"),
        );
        // alert(result.totalCount);
        Vue.$log.debug(result.list);
        this.records = result;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;
    },

    async editItem(item) {
      var paramis = {
        width: 900,
        visible: true,
        registroId: item.id,
      };
      this.setActiveTask({ task: "manejo-fechas-cobro", props: paramis });
      await this.getItems(true);
    },

    async loadSubSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("tiposSubSituacionLaboral"); // traigo todas
        this.listSubSituacionesLaborales = result.list;
        this.listSubSituacionesLaborales.push("(Todos)");
        //this.setHintSituacionLaboral();
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },

    imprimirListado() {
      let filter = this.filtro;
      const subTipoSituacionLaboralId = filter.tipoSubSituacionLaboralId || 0;

      let params = [];
      params.push({
        Anio: filter.anio, // CanalesVenta
        Mes: filter.mes, // SucursalId
        TipoSubSituacionLaboralId: subTipoSituacionLaboralId, // ProductoId
      });

      this.setReporteActivo({
        reporte: "Listado de Días de Cobro.trdp",
        params: params,
      });

      window.open("/report-viewer");
    },
  },
};
</script>
